// A server sentence worth showing, never a bare code such as
// 'account_locked' or 'rate_limited': text with at least one space, trimmed,
// else "".
export const sentence = (text) => (typeof text === "string" && /\s/.test(text.trim()) ? text.trim() : "");
